export const truncateTextToSentence = (text: string, maxLength: number): string => {
  if (text.length <= maxLength) {
    return text;
  }

  // Find the substring up to maxLength
  let truncated = text.substr(0, maxLength);

  // Find the last sentence-ending punctuation within the truncated text
  const lastPeriodIndex = truncated.lastIndexOf('.');
  const lastExclamationIndex = truncated.lastIndexOf('!');
  const lastQuestionIndex = truncated.lastIndexOf('?');

  // Determine the position of the last sentence-ending punctuation
  const lastSentenceEndIndex = Math.max(lastPeriodIndex, lastExclamationIndex, lastQuestionIndex);

  // If there's no sentence-ending punctuation within the truncated text, truncate at maxLength
  if (lastSentenceEndIndex === -1) {
    return `${truncated  }...`;
  }

  // Otherwise, truncate at the last sentence-ending punctuation
  truncated = truncated.substr(0, lastSentenceEndIndex + 1);

  return `${truncated  }...`;
}

export const splitTextIntoTwoParts = (text: string, maxLength: number): { firstPart: string; secondPart: string } => {
  if (!text) return { firstPart: '', secondPart: '' };

  if (text.length <= maxLength) {
    return {
      firstPart: text,
      secondPart: '',
    };
  }

  // Find the last space before maxLength
  let cutOff = text.lastIndexOf(' ', maxLength);
  // If no space found, force cut at maxLength
  cutOff = cutOff === -1 ? maxLength : cutOff;

  return {
    firstPart: text.substring(0, cutOff).trim(),
    secondPart: text.substring(cutOff).trim()
  };
}

export const getUrlWithScheme = (url: string): string => {
  if (url.startsWith('http')) {
    return url;
  }
  return `https://${url}`;
}

